/* global Swiper, tooltipToggle */
// *******************************************************************************
// Wizard
// *******************************************************************************
let slides = [0, 3, 5, 6];
let saveSlides = slides;
let saveSlidesAlergies = slides;
let pointer = 0;
const wizard = document.querySelector('.wizard');
let wizardInputs = wizard ? wizard.querySelectorAll('input') : '';
const resetUpcomingInputs = (slideIndex) => {
  let slide;
  const numberOfSlides = wizard.querySelectorAll('.wizard__slide').length;
  let i = slideIndex;
  for (; i <= numberOfSlides; i += 1) {
    slide = wizard.querySelector(`#wizard-slide-${i}`);
    if (slide) {
      const ansInputs = slide.querySelectorAll('input[type=checkbox], input[type=radio]');
      ansInputs.forEach((ansInput) => {
        // eslint-disable-next-line no-param-reassign
        ansInput.checked = false;
      });
    }
  }
};

const constraints = () => {
  const activeSlide = wizard.querySelector('.swiper-slide-active');
  if (activeSlide.id === 'wizard-slide-1') {
    const who = wizard.querySelector('input[name=pick-who]:checked');
    if (who) {
      switch (who.id) {
        case 'who-1':
          slides = [0, 1, 2, 3, 4, 5, 6];
          break;
        case 'who-2':
          slides = [0, 1, 2, 3, 4, 5, 6];
          break;
        case 'who-3':
          slides = [0];
          break;
        case 'who-4':
          slides = [0, 2];
          break;
        case 'who-5':
          slides = [0, 1, 2, 4, 5, 6];
          break;
        case 'who-6':
          slides = [0];
          break;
        case 'who-7':
          slides = [0];
          break;
        default:
          slides = [0, 1, 2, 3, 4, 5, 6];
          break;
      }
      saveSlides = [...slides];
      saveSlidesAlergies = [...slides];
    }
  }
  if (activeSlide.id === 'wizard-slide-4') {
    const weight = wizard.querySelector('input[name=pick-weight]:checked');
    if (weight) {
      slides = weight.id === 'weight-4' ? [0, 1, 2, 3] : (slides = [...saveSlides]);
      const softOption = wizard.querySelector('#hardness-1').parentElement;
      softOption.style.display = weight.id === 'weight-3' ? 'none' : 'flex';
    }
  }
  if (activeSlide.id === 'wizard-slide-3') {
    const partnersAllergies = wizard.querySelector('#problem-alt-9');
    const myAllergies = wizard.querySelector('#problem-alt-4');
    if (partnersAllergies.checked || myAllergies.checked) {
      if (slides.indexOf(5) !== -1) {
        slides.splice(slides.indexOf(5), 1);
      }
    } else {
      slides = [...saveSlidesAlergies];
    }
    saveSlides = [...slides];
  }
};

// ******
// Enable button input is checked
// ******
const secondaryValidateInput = (className = '') => {
  let validate = true;
  const currentSlideInputs = wizard.querySelectorAll(`.swiper-slide-active ${className} input`);
  const inputGroups = new Set(Object.values(currentSlideInputs).map((item) => item.name));
  inputGroups.forEach((el) => {
    if (wizard.querySelectorAll(`input[name=${el}]:checked`).length === 0) {
      validate = false;
    }
  });
  return validate;
};

const validateInput = () => {
  let validate = true;
  const who = wizard.querySelector('input[name=pick-who]:checked');
  const nextBtn = wizard.querySelector('.swiper-button-next');
  if (who) {
    const forKids = who.id === 'who-4';
    const coupleClass = who.id === 'who-2' ? '.couple' : '.single';
    const currentSlideInputs = wizard.querySelectorAll(`.swiper-slide-active ${coupleClass} input`);
    const problemsSlide = wizard.querySelector('.wizard__pick-problems.single #problem-1');
    problemsSlide.closest('.wizard__radio').classList.toggle('hidden', forKids);
    validate = secondaryValidateInput(currentSlideInputs.length > 0 ? coupleClass : '');
  } else {
    validate = secondaryValidateInput();
  }
  nextBtn.disabled = !validate;
};

const submintAnswers = (finalStep) => {
  const allAnswers = {};
  const allIds = {};
  const couple = wizard.querySelector('input[name=pick-who]:checked');

  const getAnwserValue = (className, property) => {
    const elem = wizard.querySelector(className);
    if (elem) {
      allAnswers[property] = elem.value;
      allIds[property] = elem.id;
    }
  };

  if (couple) {
    if (couple.id !== 'who-2') {
      [
        ['input[name=pick-who]:checked', 'who'],
        ['input[name=pick-sleep]:checked', 'sleep'],
        ['input[name=pick-weight]:checked', 'weight'],
        ['input[name=pick-hardness]:checked', 'hardness'],
        ['input[name=pick-materials]:checked', 'materials'],
        ['input[name=pick-price]:checked', 'price'],
      ].forEach(([className, property]) => getAnwserValue(className, property));

      if (wizard.querySelector('input[name=pick-problem]:checked')) {
        allAnswers.problems = Object.values(wizard.querySelectorAll('input[name=pick-problem]:checked')).map((item) => item.value);
      }
    } else {
      [
        ['input[name=pick-who]:checked', 'who'],
        ['input[name=pick-hardness-alt]:checked', 'hardness'],
        ['input[name=pick-materials]:checked', 'materials'],
        ['input[name=pick-price]:checked', 'price'],
      ].forEach(([className, property]) => getAnwserValue(className, property));

      if (wizard.querySelector('input[name=pick-sleep-alt]:checked') && wizard.querySelector('input[name=pick-sleep-alt-2]:checked'))
        allAnswers.sleep = [
          wizard.querySelector('input[name=pick-sleep-alt]:checked').value,
          wizard.querySelector('input[name=pick-sleep-alt-2]:checked').value,
        ];
      if (wizard.querySelector('input[name=pick-problem-alt]:checked') && wizard.querySelector('input[name=pick-problem-alt-2]:checked'))
        allAnswers.problems = [
          Object.values(wizard.querySelectorAll('input[name=pick-problem-alt]:checked')).map((item) => item.value),
          Object.values(wizard.querySelectorAll('input[name=pick-problem-alt-2]:checked')).map((item) => item.value),
        ];
      if (wizard.querySelector('input[name=pick-weight-alt]:checked') && wizard.querySelector('input[name=pick-weight-alt-2]:checked'))
        allAnswers.weight = [
          wizard.querySelector('input[name=pick-weight-alt]:checked').value,
          wizard.querySelector('input[name=pick-weight-alt-2]:checked').value,
        ];
    }
  }
  toggleLoader(true);
  const formData = {};
  wizard.querySelectorAll('input, textarea').forEach((input) => {
    formData[input.name] = input.value.trim();
  });
  const formDataImage = new FormData();
  formDataImage.append('action', formData.action);
  formDataImage.append('nonce', formData.nonce);
  formDataImage.append('inputIds', JSON.stringify(allIds));
  formDataImage.append('values', JSON.stringify(allAnswers));
  formDataImage.append('lang', localData.lang);
  formDataImage.append('id', localData.id);
  formDataImage.append('final-step', finalStep);
  axios
    .post(localData.siteURL, formDataImage, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then((response) => {
      if (response.status === 200 && response.data.data.url) {
        window.location = response.data.data.url;
      } else if (response.status === 200 && response.data.data.msg) {
        const priceSlider = wizard.querySelector('#wizard-slide-7 .wizard__slide-content');
        const swiperButton = document.querySelector('.wizard__footer .swiper-button-next');
        if (swiperButton) {
          swiperButton.classList.remove('swiper-button-disabled');
        }
        priceSlider.innerHTML = response.data.data.msg;
        wizardInputs = wizard.querySelectorAll('input');
        wizardInputs.forEach((input) => {
          input.addEventListener('click', () => {
            constraints();
            validateInput();
          });
        });

        const tooltipsAjax = priceSlider.querySelectorAll('.tooltip');
        const tooltipsQuestionsAjax = priceSlider.querySelectorAll('.tooltip__question');
        const tooltipsCloseAjax = priceSlider.querySelectorAll('.tooltip__modal__close');
        tooltipToggle(tooltipsQuestionsAjax, tooltipsCloseAjax, tooltipsAjax);
      }
      toggleLoader(false);
    })
    .catch((error) => {
      toggleLoader(false);
      console.log(error);
    });
};
if (wizard) {
  const wizardIntro = wizard.querySelector('.wizard__intro-wrap');
  const wizardStart = wizardIntro.querySelector('.wizard__start');
  const wizardLeave = wizard.querySelector('.leave-slider');
  const wizardSlider = wizard.querySelector('.wizard__content-wrap');

  wizardStart.addEventListener('click', () => {
    resetUpcomingInputs(0);
    validateInput();
    wizardIntro.classList.add('is-hidden');
    setTimeout(() => {
      wizardSlider.classList.add('is-active');
    }, 200);
  });

  wizardLeave.addEventListener('click', () => {
    wizardSlider.classList.remove('is-active');
    setTimeout(() => {
      wizardIntro.classList.remove('is-hidden');
    }, 200);
  });

  // *******************************************************************************

  const wizardRadios = document.querySelectorAll('.wizard__radio input');

  wizardRadios.forEach((wizardRadio) => {
    wizardRadio.addEventListener('click', () => {
      if (wizard.querySelector('.swiper-slide-active').id === 'wizard-slide-1') {
        if (wizardRadio.id === 'who-1' || wizardRadio.id === 'who-2' || wizardRadio.id === 'who-5') {
          document.querySelectorAll('.changeable-title').forEach((title) => {
            // eslint-disable-next-line no-param-reassign
            title.querySelector('h2').innerHTML = title.getAttribute(`data-${wizardRadio.id}`);
          });
        }
        wizard.classList.toggle('couples-wizard', wizardRadio.classList.contains('data-couple'));
      }
    });
  });

  // *******************************************************************************
  // Wizard slider
  // *******************************************************************************

  const wizardSliderElements = document.querySelectorAll('[data-slider="wizard-slider"]');

  const wizardSliderOptions = {
    slidesPerView: '1',
    spaceBetween: 20,
    watchOverflow: true,
    allowTouchMove: false,
    // autoHeight: true,
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    navigation: {
      nextEl: '.swiper-button-prev',
      prevEl: '.swiper-button-next',
    },
    speed: 600,
    pagination: {
      el: '.swiper-pagination',
      type: 'progressbar',
    },
  };

  wizardSliderElements.forEach((el) => {
    const wizardSliderParent = el.closest('.wizard');
    const arrowRight = wizardSliderParent.querySelector('.swiper-button-next');
    const arrowLeft = wizardSliderParent.querySelector('.swiper-button-prev');

    wizardSliderOptions.navigation.nextEl = arrowRight;
    wizardSliderOptions.navigation.prevEl = arrowLeft;

    const wizardSliderSwiper = new Swiper(el, wizardSliderOptions);

    const currentSlide = wizard.querySelector('.current-slide');
    currentSlide.innerHTML = wizardSliderSwiper.activeIndex + 1;

    wizardInputs.forEach((input) => {
      input.addEventListener('click', () => {
        constraints();
        validateInput();
      });
    });
    arrowRight.addEventListener('click', () => {
      if (pointer + 1 < slides.length) {
        if (slides[pointer + 1] === 6) {
          submintAnswers(false);
        }
        pointer += 1;
      } else {
        submintAnswers(true);
      }

      wizardSliderSwiper.slideTo(slides[pointer]);
    });

    arrowLeft.addEventListener('click', () => {
      pointer -= 1;
      wizardSliderSwiper.slideTo(slides[pointer]);
    });

    wizardSliderSwiper.on('activeIndexChange', () => {
      resetUpcomingInputs(wizardSliderSwiper.activeIndex + 2);
      currentSlide.innerHTML = wizardSliderSwiper.activeIndex + 1;
    });

    wizardSliderSwiper.on('slideChangeTransitionStart', () => {
      constraints();
      validateInput();
    });
  });

  document.body.classList.add('body-wizard-page');
}
